module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aback8-d43d3139def8e705c10e271528257f20.jpg";